/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import React, { useState } from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import { DatePicker } from './DatePicker';
import { TextField } from './TextField';
import { Radio } from './Radio';

interface Props {
  values: any;
  onFieldChange: (name: string, value: any) => any;
  baseFieldName: string;
}

export function FuturePlanUpdate({ values, onFieldChange, baseFieldName }: Props) {
  const [fields, setFields] = useState(_.get(values, baseFieldName));

  const onChange = (name: string, value: any) => {
    onFieldChange(name, value);
    setFields({
      ...fields,
      [name]: value
    });
  };

  return (
    <section className='w-full overflow-y-auto p-6 pt-3'>
      <div className='w-full'>
        <h3 className='font-medium pt-0 pb-3'>Gen Med Service</h3>
        <div className='grid gap-8' style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
          <div className='mt-auto col-span-1'>
            <DatePicker
              name='futureProducts--GM--start_dt'
              label='Effective Date'
              onChange={(v: Date) => onChange('futureProducts--GM--start_dt', v.toISOString())}
              selected={
                _.get(fields, 'futureProducts--GM--start_dt')
                  ? moment(_.get(fields, 'futureProducts--GM--start_dt')).toDate()
                  : null
              }
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--GM--member_copay'
              label='Member Pays'
              type='number'
              onChange={(v: any) => onChange('futureProducts--GM--member_copay', v.target.value)}
              value={_.get(fields, 'futureProducts--GM--member_copay')}
            />
          </div>
          <div className='ml-2'>
            <Radio
              name='futureProducts--GM--app_opt_out'
              label='USGH APP Opt-Out'
              initialValue={_.get(fields, 'futureProducts--GM--app_opt_out', false)}
              options={[
                {
                  value: true,
                  label: 'Yes'
                },
                {
                  value: false,
                  label: 'No'
                }
              ]}
              onChange={(v: any) => onChange('futureProducts--GM--app_opt_out', v)}
            />
          </div>
          <div className='mt-auto grid grid-cols-2 gap-4'>
            <Radio
              name='futureProducts--GM--could_be_less'
              label='Copay May Be Less'
              initialValue={_.get(fields, 'futureProducts--GM--could_be_less', false)}
              options={[
                {
                  value: true,
                  label: 'Yes'
                },
                {
                  value: false,
                  label: 'No'
                }
              ]}
              onChange={(v: any) => onChange('futureProducts--GM--could_be_less', v)}
            />
          </div>
        </div>
        <h3 className='font-medium pt-0 pb-3'>Derm Service</h3>
        <div className='grid gap-8' style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(160px,1fr))' }}>
          <div className='mt-auto col-span-1'>
            <DatePicker
              name='futureProducts--DERM--start_dt'
              label='Effective Date'
              onChange={(v: Date) => onChange('futureProducts--DERM--start_dt', v.toISOString())}
              selected={
                _.get(fields, 'futureProducts--DERM--start_dt')
                  ? moment(_.get(fields, 'futureProducts--DERM--start_dt')).toDate()
                  : null
              }
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--DERM--member_copay'
              label='Member Pays'
              type='number'
              onChange={(v: any) => onChange('futureProducts--DERM--member_copay', v.target.value)}
              value={_.get(fields, 'futureProducts--DERM--member_copay')}
            />
          </div>
          <div className='mt-auto grid grid-cols-2 gap-4'>
            <Radio
              name='futureProducts--DERM--could_be_less'
              label='Copay May Be Less'
              initialValue={_.get(fields, 'futureProducts--DERM--could_be_less', false)}
              options={[
                {
                  value: true,
                  label: 'Yes'
                },
                {
                  value: false,
                  label: 'No'
                }
              ]}
              onChange={(v: any) => onChange('futureProducts--DERM--could_be_less', v)}
            />
          </div>
        </div>

        <h3 className='font-medium pt-0 pb-3'>Mental Health</h3>
        <div className='grid gap-8' style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(160px,1fr))' }}>
          <div className='mt-auto col-span-1'>
            <DatePicker
              name='futureProducts--BH--start_dt'
              label='Effective Date'
              onChange={(v: Date) => onChange('futureProducts--BH--start_dt', v.toISOString())}
              selected={
                _.get(fields, 'futureProducts--BH--start_dt')
                  ? moment(_.get(fields, 'futureProducts--BH--start_dt')).toDate()
                  : null
              }
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--BH--member_copay__BHINIT'
              label='Initial Psyc'
              type='number'
              onChange={(v: any) => onChange('futureProducts--BH--member_copay__BHINIT', v.target.value)}
              value={_.get(fields, 'futureProducts--BH--member_copay__BHINIT')}
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--BH--member_copay__BHMD'
              label='Followup Psyc'
              type='number'
              onChange={(v: any) => onChange('futureProducts--BH--member_copay__BHMD', v.target.value)}
              value={_.get(fields, 'futureProducts--BH--member_copay__BHMD')}
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--BH--member_copay__BHNPT'
              label='Therapy NonMD'
              type='number'
              onChange={(v: any) => onChange('futureProducts--BH--member_copay__BHNPT', v.target.value)}
              value={_.get(fields, 'futureProducts--BH--member_copay__BHNPT')}
            />
          </div>
          <div className='mt-auto grid grid-cols-2 gap-4'>
            <Radio
              name='futureProducts--BH--could_be_less'
              label='Copay May Be Less'
              initialValue={_.get(fields, 'futureProducts--BH--could_be_less', false)}
              options={[
                {
                  value: true,
                  label: 'Yes'
                },
                {
                  value: false,
                  label: 'No'
                }
              ]}
              onChange={(v: any) => onChange('futureProducts--BH--could_be_less', v)}
            />
          </div>
        </div>

        <h3 className='font-medium pt-0 pb-3'>Primary Care</h3>
        <div className='grid gap-8' style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(160px,1fr))' }}>
          <div className='mt-auto col-span-1'>
            <DatePicker
              name='futureProducts--PRIM360CARE--start_dt'
              label='Effective Date'
              onChange={(v: Date) => onChange('futureProducts--PRIM360CARE--start_dt', v.toISOString())}
              selected={
                _.get(fields, 'futureProducts--PRIM360CARE--start_dt')
                  ? moment(_.get(fields, 'futureProducts--PRIM360CARE--start_dt')).toDate()
                  : null
              }
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--PRIM360CARE--member_copay__NEWPATCF'
              label='New patient visit'
              type='number'
              onChange={(v: any) => onChange('futureProducts--PRIM360CARE--member_copay__NEWPATCF', v.target.value)}
              value={_.get(fields, 'futureProducts--PRIM360CARE--member_copay__NEWPATCF')}
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--PRIM360CARE--member_copay__PRIMCARECF'
              label='Follow-up visit'
              type='number'
              onChange={(v: any) => onChange('futureProducts--PRIM360CARE--member_copay__PRIMCARECF', v.target.value)}
              value={_.get(fields, 'futureProducts--PRIM360CARE--member_copay__PRIMCARECF')}
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--PRIM360CARE--member_copay__PRIMCAREACF'
              label='Annual checkup visit'
              type='number'
              onChange={(v: any) => onChange('futureProducts--PRIM360CARE--member_copay__PRIMCAREACF', v.target.value)}
              value={_.get(fields, 'futureProducts--PRIM360CARE--member_copay__PRIMCAREACF')}
            />
          </div>
          <div className='mt-auto col-span-1'>
            <TextField
              name='futureProducts--PRIM360CARE--member_copay__PRIMCAREFCF'
              label='Initial flex visit'
              type='number'
              onChange={(v: any) => onChange('futureProducts--PRIM360CARE--member_copay__PRIMCAREFCF', v.target.value)}
              value={_.get(fields, 'futureProducts--PRIM360CARE--member_copay__PRIMCAREFCF')}
            />
          </div>
          <div className='mt-auto grid grid-cols-2 gap-4'>
            <Radio
              name='futureProducts--PRIM360CARE--could_be_less'
              label='Copay May Be Less'
              initialValue={_.get(fields, 'futureProducts--PRIM360CARE--could_be_less', false)}
              options={[
                {
                  value: true,
                  label: 'Yes'
                },
                {
                  value: false,
                  label: 'No'
                }
              ]}
              onChange={(v: any) => onChange('futureProducts--PRIM360CARE--could_be_less', v)}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
